import { render, staticRenderFns } from "./NotificacionAportesForm.vue?vue&type=template&id=2ce45cf0"
import script from "./NotificacionAportesForm.vue?vue&type=script&lang=ts"
export * from "./NotificacionAportesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports